let config;

const scopes = [
  'ITEMS_READ',
  'ORDERS_WRITE',
  'PAYMENTS_WRITE',
  'CUSTOMERS_WRITE',
  'CUSTOMERS_READ',
  'INVENTORY_READ',
  'MERCHANT_PROFILE_READ',
  'ORDERS_WRITE',
  'ORDERS_READ',
  'PAYMENTS_WRITE',
  'PAYMENTS_READ',
  'PAYMENTS_WRITE_ADDITIONAL_RECIPIENTS',
  'PAYMENTS_WRITE_SHARED_ONFILE',
  'DEVICE_CREDENTIAL_MANAGEMENT',
  'DEVICES_READ',
].join('+');

if (typeof window !== 'undefined') {
  config = {
    API_ENV: (window as any).env.API_ENV,
    API_URL: (window as any).env.API_URL,
    CONSUMER_URL: (window as any).env.CONSUMER_URL,
    SQUARE_AUTH_URL: (window as any).env.SQUARE_AUTH_URL,
  };
} else {
  const apis = {
    local: 'http://localhost:5000',
    development: 'https://api.dev.getnoble.co',
    staging: 'https://staging-api.getnoble.co',
    production: 'https://api.getnoble.co',
  };

  const consumerUrl = {
    local: 'http://localhost:3000',
    development: 'https://order.dev.getnoble.co',
    staging: 'https://order.stg.getnoble.co',
    production: 'https://order.getnoble.co',
  };

  const env = process.env.API_ENV || 'local';

  config = {
    API_ENV: env,
    API_URL: apis[env],
    CONSUMER_URL: consumerUrl[env],
    SQUARE_AUTH_URL:
      env === 'production'
        ? `https://connect.squareup.com/oauth2/authorize?client_id=sq0idp-bhSs3HscycN7u_xTnPC8dw&scope=${scopes}`
        : `https://connect.squareupsandbox.com/oauth2/authorize?client_id=sandbox-sq0idb-P9wAMXU5vpItHQUgGbG2sA&scope=${scopes}`,
  };
}

export default config;
